import React, { useState, useMemo } from "react";
import { Container, Row, Col, Card, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import AppHeader from "../../../components/Header/Header";
import AppFooter from "../../../components/Footer/footer"; // Ajustado para ser mais semântico que AppLayout se for só o footer
import BannerSection from '../../../components/BannerSection';
import BreadcrumbNav from '../../../components/BreadcrumbNav';

const EVENTOS_DATA = [
    {
        id: 1,
        image: require('../../../assets/ANU_02.jpg'),
        category: 'Outorga',
        date: '19 Dez 2025',
        title: '4.ª Cerimónia de Outorga de Diplomas',
        description: 'Um marco na vida académica dos nossos estudantes, celebrando a conclusão de uma etapa fundamental.',
        featured: true
    },
    {
        id: 2,
        image: require('../../../assets/jornada_cientifica-7.jpeg'),
        category: 'Académico',
        date: '05 Mai 2026',
        title: '7ª Jornada Científica Geral',
        description: 'Debatendo estratégias e processos para o desenvolvimento sustentável das instituições de ensino.',
        featured: true
    },
     {
        id: 3,
        image: require('../../../assets/ANU_02_10.jpg'),
        category: 'Investigação',
        time: '07-Abril-2023 ',
        title: 'Juventude Investigadora: Construindo o Futuro da Ciência',
        description: 'O evento proporcionou uma oportunidade única para a comunidade acadêmica trocar ideias, colaborar em projetos e promover o avanço do conhecimento científico.',
        link: '#'
    },
    {
    id: 4,
    image: require('../../../assets/ANU_02_11.jpg'),
    category: 'Comemoração',
    time: '07-Outubro-2023 ',
    title: 'Juventude, Conhecimento e Segurança: Um Compromisso Social',
    description: 'A atividade realizada, sob o tema “Juventude, Conhecimento e Segurança: Um Compromisso Social” marcou um momento de grande significado para a comunidade académica e para as forças de segurança',
    link: '#'
  },
   {
    id: 5,
    image: require('../../../assets/ANU_02_6.jpg'),
    category: 'Evento Cultural',
    time: '22-Agosto-2023 ',
    title: 'Entre Letras e Ideias: Construindo Conhecimento Através da Leitura',
    description: 'A Feira do Livro realizada sob o tema “Entre Letras e Ideias: Construindo Conhecimento Através da Leitura” celebrou a leitura como uma ponte viva entre o saber e a imaginação, entre o passado e o futuro.',
    link: '#'
  },
    {
    id: 6,
    image: require('../../../assets/ANU_02_5.jpg'),
    category: 'Área Científica',
    time: '05-Fevereiro-2024  ',
    title: 'Semana da Investigação e Extensão Universitária',
    description: 'Esta atividade não apenas valorizou o saber produzido no ambiente acadêmico, mas também fortaleceu a relação entre a universidade e a sociedade, evidenciando o compromisso institucional com a formação integral dos estudantes e com o desenvolvimento sustentável da região.',
    link: '#'
  },
   {
    id: 7,
    image: require('../../../assets/ANU_02_7.jpg'),
    category: 'Área Científica',
    time: '14-Março-2023 ',
    title: '5ª Jornada Científica Geral',
    description: 'A 5ª Jornada Científica Geral foi um marco no calendário acadêmico do Instituto Superior, reunindo estudantes, professores, investigadores e membros da comunidade em um espaço de partilha de conhecimento, experiências e inovação.',
    link: '#'
  },
  {
    id: 8,
    image: require('../../../assets/ANU_02_8.jpg'),
    category: 'Evento Cultural',
    time: '23-Maio-2024  ',
    title: 'A Universidade como Espaço de Produção de Saberes e Impacto Social',
    description: 'O evento proporcionou uma oportunidade única para a comunidade acadêmica trocar ideias, colaborar em projetos e promover o conhecimento científico.',
    link: '#'
  },
   {
    id: 9,
    image: require('../../../assets/ANU_04.jpg'),
    category: 'Área Científica',
    time: '07-Setembro-2023  ',
    title: 'Jornada Científica Geral',
    description: 'O evento teve como objetivo principal promover a produção e a divulgação do conhecimento científico nas diversas áreas do saber, incentivando a interdisciplinaridade, a inovação e o pensamento crítico.',
    link: '#'
  }

];

export default function Eventos() {
    const [filtroAtivo, setFiltroAtivo] = useState('todos');

    const caminho = [
        { label: 'Home', href: '/', icon: 'bi bi-house-door' },
        { label: 'Comunicação'},
        { label: 'Eventos'},
    ];

    // Lógica de filtragem
    const categorias = ['todos', ...new Set(EVENTOS_DATA.map(item => item.category))];
    
    const eventosFiltrados = useMemo(() => {
        return filtroAtivo === 'todos' 
            ? EVENTOS_DATA 
            : EVENTOS_DATA.filter(ev => ev.category === filtroAtivo);
    }, [filtroAtivo]);

    return (
        <div className="App" style={{ background: "#fcfcfc" }}>
            <AppHeader />
            
            <BannerSection
                title="Eventos & Notícias"
                subtitle="O pulsar da nossa comunidade académica"
                description="Fique por dentro das conferências, workshops e momentos marcantes do ISPA Atlântida."
                backgroundImage={require('../../../assets/img2.jpg')}
                backgroundId="instituition-Banner"
            />

            <BreadcrumbNav items={caminho} />

            <main className="py-5">
                <Container>
                    {/* Cabeçalho da Secção */}
                    <div className="text-center mb-5">
                        <h2 className="fw-bold mb-3" style={{ color: '#00761F' }}>Explore Nossa Agenda</h2>
                        <div className="d-flex flex-wrap justify-content-center gap-2 mb-4">
                            {categorias.map(cat => (
                                <button
                                    key={cat}
                                    onClick={() => setFiltroAtivo(cat)}
                                    className={`btn btn-sm rounded-pill px-4 transition-all ${
                                        filtroAtivo === cat ? 'btn-success shadow' : 'btn-outline-secondary'
                                    }`}
                                >
                                    {cat.charAt(0).toUpperCase() + cat.slice(1)}
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* Grid de Eventos */}
                    <Row className="g-4">
                        {eventosFiltrados.map(evento => (
                            <Col md={6} lg={4} key={evento.id}>
                                <Card as={Link} to={`/comunicacao/eventos/${evento.id}`} className="h-100 border-0 shadow-sm event-card text-decoration-none color-inherit">
                                    <div className="position-relative overflow-hidden">
                                        <Badge bg="success" className="position-absolute top-0 start-0 m-3 z-index-1 py-2 px-3 shadow-sm">
                                            {evento.category}
                                        </Badge>
                                        <Card.Img 
                                            variant="top" 
                                            src={evento.image} 
                                            style={{ height: '220px', objectFit: 'cover', transition: '0.4s' }}
                                            className="event-img"
                                        />
                                    </div>
                                    <Card.Body className="p-4">
                                        <div className="d-flex align-items-center text-muted small mb-2">
                                            <i className="bi bi-calendar3 me-2"></i>
                                            {evento.date}
                                        </div>
                                        <Card.Title className="fw-bold h5 mb-3 text-dark group-hover-green">
                                            {evento.title}
                                        </Card.Title>
                                        <Card.Text className="text-muted line-clamp-3">
                                            {evento.description}
                                        </Card.Text>
                                    </Card.Body>
                                    <Card.Footer className="bg-white border-0 p-4 pt-0">
                                        <span className="text-success fw-semibold small">
                                            Ver detalhes <i className="bi bi-arrow-right ms-1"></i>
                                        </span>
                                    </Card.Footer>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </main>

            <AppFooter />

            <style>{`
                .event-card {
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                    border-radius: 12px;
                }
                .event-card:hover {
                    transform: translateY(-8px);
                    box-shadow: 0 15px 30px rgba(0,0,0,0.1) !important;
                }
                .event-card:hover .event-img {
                    transform: scale(1.05);
                }
                .event-card:hover .group-hover-green {
                    color: #00761F !important;
                }
                .transition-all {
                    transition: all 0.3s ease;
                }
                .line-clamp-3 {
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }
                .z-index-1 {
                    z-index: 1;
                }
            `}</style>
        </div>
    );
}